import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Container } from 'components/core/Page';
import { FAQItem, SectionHeader } from 'components/molecules';
import StorageImage from 'assets/images/psp/Faq/StorageImage.svg';
import { pageTypes } from 'config/pageTypes';

import './FAQSection.scss';

export function FAQSection({
	className,
	content = { header: '', description: '', image: '', faqs: [] },
	pageType,
}) {
	const faqSchema = useMemo(() => {
		const faqs = content && Array.isArray(content.faqs) ? content.faqs : [];
		const schema = {
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			mainEntity: faqs.map((faq) => ({
				'@type': 'Question',
				name: faq.question,
				acceptedAnswer: {
					'@type': 'Answer',
					text: faq.answer,
				},
			})),
		};

		return JSON.stringify(schema);
	}, [content]);
	const {
		header = '',
		description = '',
		image = StorageImage,
		faqs = [],
	} = content;
	return (
		<div className={classnames(className, 'faq')}>
			<Container>
				<SectionHeader
					image={image}
					header={header}
					description={description}
				/>
				<FAQItem content={faqs} />
				{faqSchema && pageType !== pageTypes.SGP && (
					<script
						key="schema"
						type="application/ld+json"
						dangerouslySetInnerHTML={{
							__html: faqSchema,
						}}
					/>
				)}
			</Container>
		</div>
	);
}

FAQSection.propTypes = {
	className: PropTypes.string,
	content: PropTypes.shape({
		header: PropTypes.string,
		description: PropTypes.string,
		image: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.shape({
				src: PropTypes.string,
			}),
		]),
		faqs: PropTypes.arrayOf(
			PropTypes.shape({
				question: PropTypes.string,
				answer: PropTypes.string,
			}),
		),
	}),
	pageType: PropTypes.oneOf([pageTypes.PSP, pageTypes.SGP]),
};

export default FAQSection;
